
export const LIST_IMAGE_THUMBNAIL_SIZE_PX = 56;
